var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, makeObservable, observable } from 'mobx';
export default class Payment {
    constructor() {
        // Live eligible methods for the popup-vs-inline decision; `null` until
        // resolved from /settings (popup/modal flow is used until then).
        Object.defineProperty(this, "eligiblePaymentMethods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        // True while the /settings request is in flight (drives the Continue spinner).
        Object.defineProperty(this, "isResolvingPaymentRouting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "clear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.model = {};
                this.eligiblePaymentMethods = null;
                this.isResolvingPaymentRouting = false;
            }
        });
        Object.defineProperty(this, "setData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                this.model = Object.assign(Object.assign({}, this.model), data);
            }
        });
        Object.defineProperty(this, "setEligiblePaymentMethods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (methods) => {
                this.eligiblePaymentMethods = methods;
            }
        });
        Object.defineProperty(this, "setResolvingPaymentRouting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.isResolvingPaymentRouting = value;
            }
        });
        makeObservable(this);
    }
    get paymentMethod() {
        return this.model.method;
    }
    get paymentGateway() {
        return this.model.gateway;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Payment.prototype, "eligiblePaymentMethods", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Payment.prototype, "isResolvingPaymentRouting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Payment.prototype, "model", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Object)
], Payment.prototype, "clear", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Object)
], Payment.prototype, "setData", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Object)
], Payment.prototype, "setEligiblePaymentMethods", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Object)
], Payment.prototype, "setResolvingPaymentRouting", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Payment.prototype, "paymentMethod", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Payment.prototype, "paymentGateway", null);
